import * as React from "react";
import { UserAvatar, ListItemSecondaryContent } from "@talentpair/quantic";
import { TalentpairUser } from "@talentpair/entities/user";
import { BgTypingIndicator } from "./BgTypingIndicator";
import { MessageListItem } from "./MessageListItem";
import DATA_CARDS from "./AssistantDataCards";
import { MessageControlProps } from "../types";

function sanitize(message: string): string {
  return message.replaceAll("Hiring Search Query Advisor", "search assistant");
}

export type AssistantMessagePropsT = {
  role?: "Perry";
  message?: string;
  type?: string;
  data?: Record<string, unknown>;
  typing?: boolean;
} & MessageControlProps;

export function AssistantMessage({
  type = "",
  message = "",
  role = "Perry",
  data = {},
  typing,
  last,
  sessionid,
  addMessages,
  setBgProcess,
}: AssistantMessagePropsT): React.ReactElement | null {
  if (typing)
    return (
      <MessageListItem
        last={last}
        avatar={<UserAvatar user={TalentpairUser} />}
        title="Perry"
        content={<BgTypingIndicator />}
      />
    );

  if (!message) return null;

  return (
    <MessageListItem
      last={last}
      avatar={<UserAvatar user={TalentpairUser} />}
      title="Perry"
      content={sanitize(message)}
    >
      {type && DATA_CARDS[type] ? (
        <ListItemSecondaryContent avatar>
          {React.createElement(DATA_CARDS[type], {
            role,
            message,
            type,
            data,
            last,
            sessionid,
            addMessages,
            setBgProcess,
          })}
        </ListItemSecondaryContent>
      ) : undefined}
    </MessageListItem>
  );
}
